export const GROCERY_INSTANCES_LOADING = "GROCERY_INSTANCES_LOADING";
export const GROCERY_INSTANCES_FAILED = "GROCERY_INSTANCES_FAILED";
export const ADD_GROCERY_INSTANCES = "ADD_GROCERY_INSTANCES";
export const CROSS_OUT_GROCERY_INSTANCE = "CROSS_OUT_GROCERY_INSTANCE";
export const DELETE_GROCERY_INSTANCE = "DELETE_GROCERY_INSTANCE";

export const EDIT_GROCERY_INSTANCE_DETAIL = "EDIT_GROCERY_INSTANCE_DETAIL";
export const SHOULD_UPDATE_GROCERY_INSTANCE_DETAIL =
  "SHOULD_UPDATE_GROCERY_INSTANCE_DETAIL";
export const SUCCESS_UPDATE_GROCERY_INSTANCE_DETAIL =
  "SUCCESS_UPDATE_GROCERY_INSTANCE_DETAIL";
export const GROCERY_INSTANCE_DETAIL_FAILED = "GROCERY_INSTANCE_DETAIL_FAILED";

export const VIEW_ALL_GROCERY_INSTANCES = "VIEW_ALL_GROCERY_INSTANCES";

export const GROCERY_CATEGORIES_LOADING = "GROCERY_CATEGORIES_LOADING";
export const GROCERY_CATEGORIES_FAILED = "GROCERY_CATEGORIES_FAILED";
export const ADD_GROCERY_CATEGORIES = "ADD_GROCERY_CATEGORIES";
export const CLICK_CATEGORY = "CLICK_CATEGORY";
export const CATEGORY_SECTION_CHANGE = "CATEGORY_SECTION_CHANGE";

export const RECIPES_LOADING = "RECIPES_LOADING";
export const RECIPES_FAILED = "RECIPES_FAILED";
export const ADD_RECIPES = "ADD_RECIPES";

export const RECIPE_CATEGORIES_LOADING = "RECIPE_CATEGORIES_LOADING";
export const RECIPE_CATEGORIES_FAILED = "RECIPE_CATEGORIES_FAILED";
export const ADD_RECIPE_CATEGORIES = "ADD_RECIPE_CATEGORIES";

export const RECIPE_DETAILS_LOADING = "RECIPE_DETAILS_LOADING";
export const RECIPE_DETAILS_FAILED = "RECIPE_DETAILS_FAILED";
export const ADD_RECIPE_DETAILS = "ADD_RECIPE_DETAILS";

export const SHOULD_ADD_INGREDIENT_TO_LIST = "SHOULD_ADD_INGREDIENT_TO_LIST";
export const SUCCESSFULLY_ADDED_INGREDIENT_TO_LIST =
  "SUCCESSFULLY_ADDED_INGREDIENT_TO_LIST";
export const FAILED_ADDING_INGREDIENT_TO_LIST =
  "FAILED_ADDING_INGREDIENT_TO_LIST";

export const UNSET_REFETCH = "UNSET_REFETCH";

export const GROCERY_INSTANCES_REFETCH = "GROCERY_INSTANCES_REFETCH";

export const SET_RECIPE_CATEGORY = "SET_RECIPE_CATEGORY";

export const SET_RECIPES_CATEGORIES_FETCHED = "SET_RECIPES_CATEGORIES_FETCHED";

export const FILTER_RECIPES = "FILTER_RECIPES";

export const ADD_NEW_GROCERY = "ADD_NEW_GROCERY";
export const MODIFY_NEW_GROCERY = "MODIFY_NEW_GROCERY";
export const ADD_NEW_GROCERY_FAILED = "ADD_NEW_GROCERY_FAILED";
export const ADD_NEW_GROCERY_AGAIN = "ADD_NEW_GROCERY_AGAIN";

export const GROCERIES_LOADING = "GROCERIES_LOADING";
export const GROCERIES_FAILED = "GROCERIES_FAILED";
export const ADD_GROCERIES = "ADD_GROCERIES";

export const FILTER_GROCERIES = "FILTER_GROCERIES";

export const SET_SEARCH_ACTIVE = "SET_SEARCH_ACTIVE";

export const CHANGE_GROCERY_SEARCH_VALUE = "CHANGE_GROCERY_SEARCH_VALUE";

export const CREATE_REF = "CREATE_REF";

export const SET_HISTORY = "SET_HISTORY";

export const PAUSE_DETECTION = "PAUSE_DETECTION";

export const RESUME_DETECTION = "RESUME_DETECTION";

export const ADD_RECIPE_INGREDIENT = "ADD_RECIPE_INGREDIENT";
export const DELETE_RECIPE_INGREDIENT = "DELETE_RECIPE_INGREDIENT";
export const SET_INGREDIENT_TO_EDIT = "SET_INGREDIENT_TO_EDIT";
export const EDIT_INGREDIENT = "EDIT_INGREDIENT";
export const UPGRADE_INGREDIENTS_LIST = "UPGRADE_INGREDIENTS_LIST";

export const ADD_PREP_STEP = "ADD_PREP_STEP";
export const DELETE_PREP_STEP = "DELETE_PREP_STEP";
export const SET_PREP_STEP_TO_EDIT = "SET_PREP_STEP_TO_EDIT";
export const EDIT_PREP_STEP = "EDIT_PREP_STEP";
export const UPGRADE_PREP_STEPS_LIST = "UPGRADE_PREP_STEPS_LIST";

export const CHANGE_RECIPE_CATEGORY = "CHANGE_RECIPE_CATEGORY";

export const ADD_NEW_RECIPE = "ADD_NEW_RECIPE";
export const EDIT_RECIPE = "EDIT_RECIPE";

export const DELETE_RECIPE = "DELETE_RECIPE";
export const DELETING_RECIPE_LOADING = "DELETING_RECIPE_LOADING";

export const DISMISS_ALERT = "DISMISS_ALERT";

export const ADD_NEW_RECIPE_LOADING = "ADD_NEW_RECIPE_LOADING";
export const ADD_NEW_RECIPE_FAILED = "ADD_NEW_RECIPE_FAILED";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
